import React, { useState } from "react";
import TreeViewNested from "./TreeViewNested";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

interface Props {
  data: any;
  onSelect: (id: number | undefined) => void;
  selectedId: number | string;
  hide: string[];
}

const RecursiveComponent: React.FC<Props> = ({
  data,
  onSelect,
  selectedId,
  hide
}) => {
  const [active, setActive] = useState(true);
  const handleClick = (value: boolean) => {
    setActive(value);
    onSelect(data.id);
  };
  return (
    <li>
      <span
        className={`
          caret ${active ? "caret-down" : ""}
          ${selectedId === data.id ? "selected" : ""}
          ${data.children.length === 0 ? "hide-caret" : ""}
          ${hide.includes(data.id) ? 'hide' : ''}
        `}
        onClick={(e: any) => handleClick(!active)}
      >
        {data.children.length > 0 &&
          (active ? <ExpandMoreIcon /> : <ChevronRightIcon />)}
        {data.name}
      </span>
      <TreeViewNested active={active}>
        {data.children.map((e: any, i: number) => {
          return (
            <RecursiveComponent
              onSelect={onSelect}
              data={e}
              selectedId={selectedId}
              key={i}
              hide={hide}
            />
          );
        })}
      </TreeViewNested>
    </li>
  );
};

export default RecursiveComponent;